


export const colorsPalette = [
      '#00B69B', '#32ADE6', '#6A5CA8', '#FF9500', '#EF1E1A',
      '#008F7B', '#66D9C2', '#2564A6', '#7AD4F0', '#563E7D',
      '#A58ECE', '#CC7700', '#FFB84D', '#B31713', '#F56B6A',
      '#1D855A', '#0F78A1', '#4D3C85', '#D97A00', '#C31F1D'
]